export default "__VITE_ASSET__BYc50sGx__"